/**
 * cookieCleanup - removes known cookies for categories the user has revoked.
 *
 * Add entries here for any third-party SDK we adopt so its cookies are wiped on revoke.
 * Names can be exact strings or prefix strings ending with '*'.
 *
 * Start empty — no third-party trackers are installed today. Add entries when adopting one.
 */

export const COOKIE_MAP = {
    necessary: [],
    analytics: [
        // Examples (add when adopted):
        // '_ga', '_ga_*', '_gid', '_gat', '_gat_*', // Google Analytics
        // 'mp_*',                                     // Mixpanel
        // 'ph_*',                                     // PostHog
    ],
    marketing: [
        // '_fbp', 'fr',     // Meta Pixel
        // '_ttp',           // TikTok
        // 'IDE', 'ANID',    // Google Ads / DoubleClick
    ],
    personalization: [
        // Add personalization SDK cookies here
    ],
};

function nameMatches(cookieName, pattern) {
    if (pattern.endsWith('*')) {
        return cookieName.startsWith(pattern.slice(0, -1));
    }
    return cookieName === pattern;
}

function listCookieNames() {
    if (typeof document === 'undefined' || !document.cookie) return [];
    return document.cookie.split(';').map((c) => c.split('=')[0].trim()).filter(Boolean);
}

function deleteCookie(name) {
    if (typeof document === 'undefined') return;
    const host = window.location.hostname;
    // Strip subdomains progressively to cover both host-only and parent-domain cookies.
    const parts = host.split('.');
    const domains = [''];
    for (let i = 0; i < parts.length - 1; i++) {
        domains.push('; domain=' + parts.slice(i).join('.'));
        domains.push('; domain=.' + parts.slice(i).join('.'));
    }
    const paths = ['/', window.location.pathname];
    for (const d of domains) {
        for (const p of paths) {
            document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=${p}${d}`;
        }
    }
}

/**
 * Delete cookies for categories the user did NOT consent to.
 * Cookies for the necessary category, plus our own tx_* infrastructure cookies, are never touched.
 */
export function cleanupCookies(consent) {
    if (!consent) return;
    const cookieNames = listCookieNames();
    for (const [category, patterns] of Object.entries(COOKIE_MAP)) {
        if (category === 'necessary') continue;
        if (consent[category]) continue;
        for (const pattern of patterns) {
            for (const name of cookieNames) {
                if (nameMatches(name, pattern)) deleteCookie(name);
            }
        }
    }
}

export default cleanupCookies;
